import * as React from "react";

function SvgStatusLoading(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.435 59.828c-13.16-4.178-20.44-18.233-16.263-31.393 4.178-13.16 18.233-20.441 31.393-16.263a25.06 25.06 0 015.422 2.46l2.144-3.38a29.07 29.07 0 00-6.355-2.892C29.51 3.513 13.206 11.96 8.36 27.224c-4.847 15.266 3.6 31.57 18.864 36.416 15.266 4.847 31.57-3.599 36.416-18.864a28.876 28.876 0 00-.493-18.981l-3.76 1.368a24.893 24.893 0 01.441 16.402c-4.178 13.16-18.233 20.441-31.393 16.263z"
        fill="#27AE60"
      />
    </svg>
  );
}

export default SvgStatusLoading;
